import { Accordion, AccordionContent, AccordionHeader, AccordionItem } from '@ordr-as/umami-react/accordion';
import { Badge } from '@ordr-as/umami-react/badge';
import type { MenuSectionDto } from '../../../../generated-api';
import { useSearch } from '../../../context/SearchContext';
import { getMappedMenusByLocation } from './mappedMenusByLocation';
import MenuSectionButton from './MenuSectionButton';

interface MenuAccordionProps {
  handleSectionClick: (menuSection: MenuSectionDto) => void;
  sections: MenuSectionDto[];
  selectedSectionId?: string;
}

const MenuAccordion = (props: MenuAccordionProps) => {
  const { sections, handleSectionClick, selectedSectionId } = props;
  const { searchText } = useSearch();
  const locationMenus = getMappedMenusByLocation(sections);

  const selectedLocation = sections.find((section) => selectedSectionId === section.sectionId)?.locationId;

  const handleLocationClick = (locationId: string) => {
    const locationMenu = locationMenus.find((menu) => menu.locationId.toString() === locationId);
    const firstSection = locationMenu?.sections[0];

    if (!firstSection) {
      return;
    }

    handleSectionClick(firstSection);
  };

  return (
    <Accordion onValueChange={handleLocationClick} value={selectedLocation?.toString()}>
      {locationMenus.map((locationMenu) => (
        <AccordionItem key={locationMenu.locationId} value={locationMenu.locationId.toString()}>
          <AccordionHeader
            text={locationMenu.locationName}
            rightBadge={
              searchText.length !== 0 && (
                <Badge
                  text={locationMenu.sections
                    .reduce(
                      (prev, current) =>
                        prev + current.items.length + current.subsections.reduce((s, sub) => s + sub.items.length, 0),
                      0
                    )
                    .toString()}
                />
              )
            }
            className="px-2"
          />
          <AccordionContent>
            {locationMenu.sections.map((menuSection) => (
              <MenuSectionButton
                key={menuSection.sectionId}
                active={menuSection.sectionId === selectedSectionId}
                menuSection={menuSection}
                handleSectionClick={handleSectionClick}
              />
            ))}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default MenuAccordion;
